import { faCookieBite } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";
import { useCookieConsent } from "react-cookie-manager";
import { useMediaQuery } from "react-responsive";
import { Link, useMatches } from "react-router-dom";
import ChoiceIcon from "../../components/ChoiceIcon";

export default function Footer() {
    const cookieConsent = useCookieConsent();
    const matches = useMatches();

    const isMobile = useMediaQuery({
        query: "(max-width: 1024px)",
    });

    const currentMatch = [...matches].reverse().find(
        (match) => match.handle?.breadcrumbs
    );

    const breadcrumbs = currentMatch?.handle?.breadcrumbs || [
        {
            label: "Home",
            link: "/",
        },
    ];

    const footerSections = useMemo(
        () => [
            {
                title: "SOLUTIONS",
                links: [
                    { label: "ADVERTISERS", to: "/advertisers" },
                    { label: "PUBLISHERS", to: "/publishers" },
                ],
            },
            {
                title: "ABOUT",
                links: [
                    { label: "CONTACT", to: "/contact" },
                    { label: "OPTOUT", to: "/opt-out" },
                    {
                        label: "KVKK (Personal Data Protection Law) Information Text",
                        to: "/kvkk",
                    },
                    {
                        label: "Privacy Policy and Cookie Usage",
                        to: "/privacy-policy-and-cookie-usage",
                    },
                    {
                        label: "Application to the Data Controller (PDF)",
                        href: "/application-to-data-controller.pdf",
                        target: "_blank",
                    },
                    { label: "Your Privacy Choices", onClick: () => cookieConsent?.openPreferencesModal() },
                ],
            },
            {
                title: "FOR DEVELOPERS",
                links: [
                    {
                        label: "DOCUMENTS",
                        href: "https://developer.pixad.com.tr/",
                        target: "_blank",
                    },
                ],
            },
        ],
        []
    );

    const renderFooterLink = (item) => {
        if (item.to) {
            return <Link to={item.to}>{item.label}</Link>;
        }

        if (item.href) {
            return (
                <a
                    href={item.href}
                    target={item.target || "_self"}
                    rel={item.target === "_blank" ? "noopener noreferrer" : undefined}
                >
                    {item.label}
                </a>
            )
        }


        if (item.onClick) {
            return (
                <a
                    href="#"
                    style={{display: "flex", gap: 5, alignItems: "center"}}
                    onClick={(e) => {
                        e.preventDefault();
                        item.onClick();
                    }}
                >
                    {item.label}
                    <ChoiceIcon width={32} height={32}/>
                </a>
            );
        }

        return null;
    };

    return (
        <footer className="footer">
            <div>
                <div className="top-footer">
                    <div className="footer-breadcrumbs">
                        <ul>
                            {breadcrumbs.map((item, index) => {
                                const isLast = index === breadcrumbs.length - 1;

                                return (
                                    <li key={item.link || item.label || index}>
                                        {isLast ? (
                                            <span>{item.label}</span>
                                        ) : (
                                            <Link to={item.link}>{item.label}</Link>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    <div className="footer-nav">
                        {isMobile ? (
                            <div className="mobile-nav">
                                <ul>
                                    {footerSections.flatMap((section) =>
                                        section.links.map((item) => (
                                            <li key={item.to || item.href || item.onClick}>
                                                {renderFooterLink(item)}
                                            </li>
                                        ))
                                    )}
                                </ul>
                            </div>
                        ) : (
                            <div className="navmenu">
                                <ul>
                                    {footerSections.map((section) => (
                                        <li key={section.title}>
                                            <div>
                                                <div>
                                                    <span>{section.title}</span>
                                                </div>
                                                <ul>
                                                    {section.links.map((item) => (
                                                        <li key={item.to || item.href || item.onClick}>
                                                            {renderFooterLink(item)}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>

                <div className="bottom-footer">
                    <div>
                        <div className="footer-actions">
                            {isMobile && (
                                <>
                                    <a
                                        className="action-button-fill primary"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://apps.pixad.com.tr/auth/sign-up"
                                    >
                                        CREATE ACCOUNT
                                    </a>
                                    <a
                                        className="action-button-normal"
                                        href="https://apps.pixad.com.tr/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        LOGIN
                                    </a>
                                </>
                            )}
                        </div>
                    </div>

                    <div>
                        <div>
                            <ul>
                                <li>© 2024 Pixad. All rights reserved.</li>
                                <li>
                                    <Link to="/user-agreement">User Agreement</Link>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}